export default __webpack_public_path__ + "static/media/SlideThree.0086d093.png";